import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const FAQS = [{
  q: '¿Cómo recibo el Kit después de comprar?',
  a: 'En pocos minutos recibirás un correo con el acceso a todo el material digital. Podrás descargarlo al instante y empezar tu Día 1 ese mismo día.'
}, {
  q: '¿Necesito conocimientos previos o experiencia en terapia?',
  a: 'Para nada. El Método RESET™ está diseñado para cualquier persona. Todo está explicado paso a paso, con ejercicios simples y guiados. Solo necesitas 15 minutos al día.'
}, {
  q: '¿Cuánto tiempo tengo que dedicarle al día?',
  a: 'Solo 15 minutos diarios. El sistema está pensado para que avances a tu propio ritmo, sin agregar más presión ni más tareas a tu día.'
}, {
  q: '¿En qué dispositivos puedo usarlo?',
  a: 'En todos. Puedes usar el material desde tu computadora, tablet o celular. También puedes imprimirlo si prefieres escribir a mano.'
}, {
  q: '¿Es un pago único o una suscripción?',
  a: 'Es un único pago de $17 USD. No hay cargos recurrentes, ni suscripciones, ni sorpresas. Pagas una vez y el material es tuyo para siempre.'
}, {
  q: '¿Y si siento que no es para mí?',
  a: 'Cuentas con nuestra Garantía de satisfacción de 14 días. Si el Kit no es lo que esperabas, te devolvemos el 100% de tu inversión, sin preguntas incómodas.'
}];
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="mb-16" data-id="element-15">
      <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-[#5d4a6e] mb-10" data-id="element-16">
        Preguntas frecuentes
      </h2>
      <div className="max-w-2xl mx-auto space-y-4" data-id="element-17">
        {FAQS.map((faq, i) => {
        const isOpen = openIndex === i;
        return <div key={i} className="bg-white rounded-2xl shadow-sm border border-[#f0e6d2] overflow-hidden" data-id="element-18">
              <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} className="w-full flex items-center justify-between gap-4 text-left px-6 py-5" data-id="element-19">
                <span className="font-bold text-[#5d4a6e] text-base md:text-lg" data-id="element-20">
                  {faq.q}
                </span>
                <motion.span animate={{
              rotate: isOpen ? 180 : 0
            }} transition={{
              duration: 0.2
            }} className="shrink-0 text-[#c08a92]" data-id="element-21">
                  <ChevronDown size={22} data-id="element-22" />
                </motion.span>
              </button>
              <AnimatePresence initial={false} data-id="element-23">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.25
            }} className="overflow-hidden" data-id="element-24">
                    <p className="px-6 pb-5 text-gray-600 leading-relaxed" data-id="element-25">
                      {faq.a}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </section>;
}